<template>
  <div class="animated fadeIn" v-if="form">
    <vue-headful :title="form.formName + ` - Formularz`" />
    <b-row>
      <b-col lg="6" xl="6">
        <b-row>
          <b-col cols="12" sm="12">
            <b-card>
              <div slot="header"><strong>{{ form.formName }}</strong>
                <small class="float-right">
                  <b-button size="sm" type="button" variant="primary" @click="editFormModal = true" title="Edytuj formularz">
                    <i class="fa fa-pencil"></i>&nbsp; Edytuj
                  </b-button>
                </small>
              </div>
              <c-form-overview :form="form"></c-form-overview>
            </b-card>
            <div class="form-actions"></div>
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="6" xl="6">
        <b-row>
          <b-col xl="12">
            <b-card header-tag="header" footer-tag="footer">
              <div slot="header">
                <i class="fa fa-envelope-o"></i> Powiadomienia e-mail
                <b-button variant="primary" size="sm" class="float-right" @click="createEmailNotificationModal = true"><i class="fa fa-plus"></i> Dodaj</b-button>
              </div>
              <b-list-group v-if="form.notifications.email.length > 0">
                <b-list-group-item v-bind:key="notification.id" v-bind:item="notification" v-for="notification in form.notifications.email">
                  <span class="cursor-pointer" @click="editEmailNotificationModal = true; currentEmailNotification = notification">
                    <b>{{ notification.recipients.direct.join(', ') }}</b> - {{ notification.messageTemplate.title }}
                  </span>
                  <c-notification-buttons class="float-right"
                    :checked="notification.status === 'ACTIVE'"
                    @paused="pauseEmailNotification(notification)"
                    @activated="activateEmailNotification(notification)"
                    @removed="removeEmailNotification(notification)"
                  />
                </b-list-group-item>
              </b-list-group>
              <span v-else><i>Brak powiadomień</i></span>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="6">
            <b-card header-tag="header" footer-tag="footer">
              <div slot="header">
                <i class="fa fa-mobile-phone"></i> Powiadomienia SMS
                <b-button variant="primary" size="sm" class="float-right" @click="createSmsNotificationModal = true"><i class="fa fa-plus"></i> Dodaj</b-button>
              </div>
              <b-list-group v-if="form.notifications.sms.length > 0">
                <b-list-group-item v-bind:key="notification.id" v-bind:item="notification" v-for="notification in form.notifications.sms">
                  <span class="cursor-pointer" @click="editSmsNotificationModal = true; currentSmsNotification = notification">{{ notification.recipient }} </span>
                  <c-notification-buttons class="float-right"
                      :checked="notification.status === 'ACTIVE'"
                      @paused="pauseSmsNotification(notification)"
                      @activated="activateSmsNotification(notification)"
                      @removed="removeSmsNotification(notification)"
                  />
                </b-list-group-item>
              </b-list-group>
              <span v-else><i>Brak powiadomień</i></span>
            </b-card>
          </b-col>
          <b-col xl="6">
            <b-card header-tag="header" footer-tag="footer">
              <div slot="header">
                <i class="fa fa-link"></i> Webhooki
                <b-button variant="primary" size="sm" class="float-right" @click="createWebhookModal = true"><i class="fa fa-plus"></i> Dodaj</b-button>
              </div>
              <b-list-group v-if="form.webhooks.length > 0">
                <b-list-group-item v-bind:key="webhook.id" v-bind:item="webhook" v-for="webhook in form.webhooks">
                  <span class="cursor-pointer" @click="editWebhookModal = true; currentWebhook = webhook">
                    <span>{{ webhook.description }} </span>
                    <b-badge class="rounded-pill">{{ webhook.event }}</b-badge>
                  </span>
                  <c-notification-buttons class="float-right"
                    :checked="webhook.status === 'ACTIVE'"
                    @paused="pauseWebhook(webhook)"
                    @activated="activateWebhook(webhook)"
                    @removed="removeWebhook(webhook)"
                  />
                </b-list-group-item>
              </b-list-group>
              <span v-else><i>Brak webhooków</i></span>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="12">
            <b-card header-tag="header" footer-tag="footer">
              <div slot="header">
                <i class="fa fa-desktop"></i> Instalacja formularza
              </div>
              <div>
                <a :href="installationLink()" target="_blank">{{ installationLink() }}</a>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <div class="modals">
      <b-modal size="md" hide-footer no-footer title="Nowe powiadomienie SMS" class="modal-primary" v-model="createSmsNotificationModal">
        <c-sms-notification-creator :variables="availableVariables" @saved="createSmsNotification"></c-sms-notification-creator>
      </b-modal>
      <b-modal size="md" hide-footer no-footer title="Edycja powiadomienia SMS" class="modal-primary" v-model="editSmsNotificationModal">
        <c-sms-notification-creator :init-notification="currentSmsNotification" :variables="availableVariables" @saved="editSmsNotification"></c-sms-notification-creator>
      </b-modal>
      <b-modal size="lg" hide-footer no-footer title="Nowe powiadomienie e-mail" class="modal-primary" v-model="createEmailNotificationModal">
        <c-email-notification-creator :variables="availableVariables" @saved="createEmailNotification"></c-email-notification-creator>
      </b-modal>
      <b-modal size="lg" hide-footer no-footer title="Edycja powiadomienia e-mail" class="modal-primary" v-model="editEmailNotificationModal">
        <c-email-notification-creator :init-notification="currentEmailNotification" :variables="availableVariables" @saved="editEmailNotification"></c-email-notification-creator>
      </b-modal>
      <b-modal size="md" hide-footer no-footer title="Nowy webhook" class="modal-primary" v-model="createWebhookModal">
        <c-webhook-creator :variables="availableVariables" @saved="createWebhook"></c-webhook-creator>
      </b-modal>
      <b-modal size="md" hide-footer no-footer title="Edycja webhooka" class="modal-primary" v-model="editWebhookModal">
        <c-webhook-creator :init-webhook="currentWebhook" :variables="availableVariables" @saved="editWebhook"></c-webhook-creator>
      </b-modal>
      <b-modal v-if="form" size="lg" hide-footer no-footer :title="`Edycja ` + form.formName" class="modal-primary" v-model="editFormModal">
        <c-form-creator :projects="[{id: form.projectId, name: form.projectName}]" :init-form="form" @saved="editForm"></c-form-creator>
      </b-modal>
    </div>
  </div>
</template>

<script>
import leadsClient from '../../service/leadsClient'
import vueHeadful from 'vue-headful'
import CFormOverview from '../../components/Form/FormOverview'
import CSmsNotificationCreator from '../../components/Form/Notification/SmsNotificationCreator'
import CEmailNotificationCreator from '../../components/Form/Notification/EmailNotificationCreator'
import CFormCreator from '../../components/Form/FormCreator'
import CWebhookCreator from '../../components/Form/WebhookCreator'
import config from '../../config'
import CNotificationButtons from '../../components/Form/Notification/NotificationButtons'

export default {
  name: 'forms-single',
  props: ['formId'],
  components: {
    CNotificationButtons,
    vueHeadful,
    CFormOverview,
    CSmsNotificationCreator,
    CEmailNotificationCreator,
    CWebhookCreator,
    CFormCreator
  },
  data () {
    return {
      form: null,
      availableVariables: [],
      editFormModal: false,
      currentSmsNotification: null,
      createSmsNotificationModal: false,
      editSmsNotificationModal: false,
      currentEmailNotification: null,
      createEmailNotificationModal: false,
      editEmailNotificationModal: false,
      currentWebhook: null,
      createWebhookModal: false,
      editWebhookModal: false
    }
  },
  created () {
    this.getForm()
  },
  methods: {
    async getForm () {
      this.form = await leadsClient.getForm(this.formId)
      const self = this
      this.availableVariables = ['{overviewUrl}', '{formId}', '{leadId}']
      this.form.inputs.forEach(input => {
        self.availableVariables.push('{' + input.name + '}')
      })
    },
    async createSmsNotification (notification) {
      await leadsClient.createSmsNotification(this.formId, notification)
      this.createSmsNotificationModal = false
      this.$notify({ group: 'notify', type: 'success', title: 'Dodano powiadomienie SMS', text: '' })
      await this.getForm()
    },
    async editSmsNotification (notification) {
      await leadsClient.editSmsNotification(this.formId, notification)
      this.editSmsNotificationModal = false
      this.$notify({ group: 'notify', type: 'success', title: 'Zapisano zmiany', text: '' })
      await this.getForm()
    },
    async removeSmsNotification (notification) {
      await this.$confirm('Na pewno usunąć powiadomienie SMS do ' + notification.recipient + '?', '', '', { confirmButtonText: 'Tak', cancelButtonText: 'Nie' })
      await leadsClient.removeSmsNotification(this.formId, notification.id)
      this.$notify({ group: 'notify', type: 'success', title: 'Usunięto powiadomienie SMS', text: '' })
      await this.getForm()
    },
    async pauseSmsNotification (notification) {
      await leadsClient.pauseSmsNotification(this.formId, notification.id)
      this.$notify({ group: 'notify', type: 'success', title: 'Powiadomienie SMS wstrzymane', text: '' })
      await this.getForm()
    },
    async activateSmsNotification (notification) {
      await leadsClient.activateSmsNotification(this.formId, notification.id)
      this.$notify({ group: 'notify', type: 'success', title: 'Powiadomienie SMS aktywowane', text: '' })
      await this.getForm()
    },
    async createEmailNotification (notification) {
      await leadsClient.createEmailNotification(this.formId, notification)
      this.createEmailNotificationModal = false
      this.$notify({ group: 'notify', type: 'success', title: 'Dodano powiadomienie e-mail', text: '' })
      await this.getForm()
    },
    async editEmailNotification (notification) {
      await leadsClient.editEmailNotification(this.formId, notification)
      this.editEmailNotificationModal = false
      this.$notify({ group: 'notify', type: 'success', title: 'Zapisano zmiany', text: '' })
      await this.getForm()
    },
    async removeEmailNotification (notification) {
      await this.$confirm('Na pewno usunąć powiadomienie e-mail ' + notification.messageTemplate.title + '?', '', '', { confirmButtonText: 'Tak', cancelButtonText: 'Nie' })
      await leadsClient.removeEmailNotification(this.formId, notification.id)
      this.$notify({ group: 'notify', type: 'success', title: 'Usunięto powiadomienie e-mail', text: '' })
      await this.getForm()
    },
    async pauseEmailNotification (notification) {
      await leadsClient.pauseEmailNotification(this.formId, notification.id)
      this.$notify({ group: 'notify', type: 'success', title: 'Powiadomienie e-mail wstrzymane', text: '' })
      await this.getForm()
    },
    async activateEmailNotification (notification) {
      await leadsClient.activateEmailNotification(this.formId, notification.id)
      this.$notify({ group: 'notify', type: 'success', title: 'Powiadomienie e-mail aktywowane', text: '' })
      await this.getForm()
    },
    async createWebhook (webhook) {
      await leadsClient.createWebhook(this.formId, webhook)
      this.createWebhookModal = false
      this.$notify({ group: 'notify', type: 'success', title: 'Dodano webhook', text: '' })
      await this.getForm()
    },
    async editWebhook (webhook) {
      await leadsClient.editWebhook(this.formId, webhook)
      this.editWebhookModal = false
      this.$notify({ group: 'notify', type: 'success', title: 'Zapisano zmiany', text: '' })
      await this.getForm()
    },
    async removeWebhook (webhook) {
      await this.$confirm('Na pewno chcesz usunąć webhook ' + webhook.description + '?', '', '', { confirmButtonText: 'Tak', cancelButtonText: 'Nie' })
      await leadsClient.removeWebhook(this.formId, webhook.id)
      this.$notify({ group: 'notify', type: 'success', title: 'Usunięto webhook', text: '' })
      await this.getForm()
    },
    async pauseWebhook (webhook) {
      await leadsClient.pauseWebhook(this.formId, webhook.id)
      this.$notify({ group: 'notify', type: 'success', title: 'Webhook wstrzymany', text: '' })
      await this.getForm()
    },
    async activateWebhook (webhook) {
      await leadsClient.activateWebhook(this.formId, webhook.id)
      this.$notify({ group: 'notify', type: 'success', title: 'Webhook aktywowany', text: '' })
      await this.getForm()
    },
    async editForm (form) {
      await leadsClient.editForm(form)
      this.editFormModal = false
      this.$notify({ group: 'notify', type: 'success', title: 'Zapisano zmiany', text: '' })
      await this.getForm()
    },
    installationLink () {
      return config.services.publicLeads.url + '/api/public/form-overview/' + this.formId
    }
  }
}
</script>
